import { TileLayer } from "react-leaflet";

// Carte de référence WÔMA (accueil) : OpenStreetMap + filtre sombre .woma-dark-tiles (index.css), sans clé
export const DarkTiles = () => (
  <TileLayer
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    attribution="&copy; OpenStreetMap"
    className="woma-dark-tiles"
    maxZoom={19}
  />
);
